<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-request-sidebar ref="productRequestSidebar" />

    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div>
        <div v-if="!isEditing" class="flex justify-end">
          <vs-button
            icon="edit"
            @click="startEditing"
            type="relief"
            color="primary"
            class="mr-3"
            >Edit products</vs-button
          >
          <vs-button
            icon="edit"
            @click="
              $router.push({ name: 'vp-pim-desired-stock' }).catch(() => {})
            "
            type="relief"
            color="primary"
            class="mr-3"
            >Set desired stock</vs-button
          >
          <vs-button
            icon="add"
            @click="
              $router.push({ name: 'vp-pim-stock-transfers' }).catch(() => {})
            "
            type="relief"
            color="primary"
            class="mr-3"
            >View stock transfers</vs-button
          >
        </div>
        <div v-else class="flex justify-end">
          <vs-row>
            <vs-button
              icon="save"
              @click="savePouringCategories"
              type="relief"
              color="primary"
              class="mr-3"
            >
              Save changes
            </vs-button>
            <vs-button
              icon="close"
              @click="cancelEdit"
              type="border"
              color="primary"
              class="mr-3"
            >
              Cancel
            </vs-button>
          </vs-row>
        </div>
      </div>
    </div>

    <h5 class="mt-6 mb-5">Filter by location</h5>
    <!-- <vs-row vs-justify="flex-start" class="mt-4">
      <vs-button
        v-for="location in pimStockLocations.locations"
        :key="location.id"
        :class="{
          'rounded-l-lg': location.id === pimStockLocations.locations[0].id,
          'rounded-r-lg':
            location.id ===
            pimStockLocations.locations[pimStockLocations.locations.length - 1]
              .id,
        }"
        class="rounded-none w-48"
        :color="filterByLocationId === location.id ? 'primary' : 'grey'"
        @click="
          filterByLocationId === location.id
            ? (filterByLocationId = null)
            : (filterByLocationId = location.id)
        "
        :icon="filterByLocationId === location.id ? 'check' : ''"
      >
        {{ location.name }}
      </vs-button>
    </vs-row> -->

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        v-model="selected"
        pagination
        search
        max-items="8"
        :data="filteredVenueStock"
      >
        <template slot="header">
          <vs-button
            v-for="location in pimStockLocations.locations"
            :key="location.id"
            :class="{
              'rounded-l-lg': location.id === pimStockLocations.locations[0].id,
              'rounded-r-lg':
                location.id ===
                pimStockLocations.locations[
                  pimStockLocations.locations.length - 1
                ].id,
            }"
            class="rounded-none px-3 py-3"
            :style="
              location.id !== pimStockLocations.locations[0].id
                ? 'border-left: 1px solid #666 !important'
                : ''
            "
            style="margin-top: -10px"
            :color="filterByLocationId === location.id ? 'primary' : 'grey'"
            @click="
              filterByLocationId === location.id
                ? (filterByLocationId = null)
                : (filterByLocationId = location.id)
            "
            :icon="filterByLocationId === location.id ? 'check' : ''"
          >
            {{ location.name }}
          </vs-button>

          <div class="flex ml-4 mb-2">
            <vs-select
              v-model="filters.pouringCategory"
              placeholder="Filter by pouring category"
            >
              <vs-select-item key="noItem" :value="null" text="All" />
              <vs-select-item
                :key="item.venueProductCategoryId.id"
                :value="item.venueProductCategoryId.id"
                :text="item.name"
                v-for="item in pouringCategories"
              />
            </vs-select>
          </div>
          <vs-spacer />
        </template>
        <template slot="thead">
          <vs-th sort-key="number">Product id</vs-th>
          <vs-th sort-key="stockProductName">Name</vs-th>
          <vs-th sort-key="unitPrice">Cost price</vs-th>
          <vs-th sort-key="stockAmount">Amount</vs-th>
          <vs-th v-if="hasRole('rm')" sort-key="deviation">Deviation</vs-th>
          <vs-th sort-key="stockValue">Stock value</vs-th>
          <vs-th sort-key="pouringCategory">Pouring category</vs-th>
          <vs-th sort-key="salePrice">Sale price</vs-th>
          <vs-th sort-key="lastStockTake">Last stocktake date</vs-th>
          <vs-th sort-key="lastStockTakeUser">Last stocktake user</vs-th>
          <!-- <vs-th>Stock status</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                  <p class="ml-4">{{ tr.stockProductId.id }}</p>
                </div>
              </vs-td>
              <vs-td>
                <div>
                  {{ tr.stockProductName }}
                </div>
              </vs-td>
              <vs-td>
                <div>
                  {{ tr.unitPrice }}
                </div>
              </vs-td>

              <vs-td>
                <div>
                  {{ tr.stockAmount }}
                </div>
              </vs-td>

              <vs-td v-if="hasRole('rm')">
                <div>
                  {{ tr.deviation }}
                </div>
              </vs-td>

              <vs-td>
                <div>
                  {{ tr.stockValue }}
                </div>
              </vs-td>

              <vs-td>
                <div v-if="isEditing">
                  <vs-select
                    :value="
                      tr.pouringCategory
                        ? tr.pouringCategory.venueProductCategoryId.id
                        : null
                    "
                    @input="(e) => onChangedPouringCategory(tr, e)"
                    placeholder="No pouring category"
                  >
                    <vs-select-item
                      :key="item.venueProductCategoryId.id"
                      :value="item.venueProductCategoryId.id"
                      :text="item.name"
                      v-for="item in pouringCategories"
                    />
                  </vs-select>
                </div>
                <div v-else>
                  <vs-chip v-if="tr.pouringCategory" color="primary">
                    {{ tr.pouringCategory.venueProductCategoryName }}
                  </vs-chip>
                  <vs-chip v-else><i> No pouring category </i></vs-chip>
                </div>
              </vs-td>

              <vs-td>
                <div v-if="isEditing">
                  <vs-input
                    :value="tr.salesPrice"
                    @input="
                      (e) => {
                        tr.salesPrice = e;
                        onChangedPrice(tr, e);
                      }
                    "
                  />
                </div>
                <div v-else>
                  <code>
                    {{ tr.salesPrice }}
                  </code>
                </div>
              </vs-td>

              <vs-td>
                <div v-if="isValidDate(tr.lastStocktake)">
                  {{ tr.lastStocktake }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="isValidDate(tr.lastStocktake)">
                  {{ tr.lastStocktakeUser }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleProductRequestSidebar from "./HandleProductRequestSidebar";
import moment from "moment";

export default {
  components: {
    HandleProductRequestSidebar,
  },
  data() {
    return {
      selected: [],
      filterByLocationId: "",
      isLoading: true,
      ProductIcon,
      currentPage: 1,
      pageSize: 10,

      isEditing: false,
      changedProductCategories: [],
      changedProductPricings: [],

      filters: {
        pouringCategory: null,
      },
    };
  },
  methods: {
    onClicked(id) {
      this.$refs.productRequestSidebar.show(id);
    },
    async onClickCreateNew() {
      this.$refs.productRequestSidebar.showEmptyProduct();
    },

    // Check if date is valid using moment
    isValidDate(date) {
      if (!date) return false;
      return moment(date).year() > 1;
    },

    getStockLocationStatusString(stocks) {
      return stocks
        .map((e) => {
          // const location = this.pimStockLocations.locations.find(l => l.id === e.stockId.id);
          return `${e.desiredAmount}`;
        })
        .join(" ");
    },

    getStockProductExplanationString(stocks) {
      return stocks
        .map((e) => {
          const location = this.pimStockLocations.locations.find(
            (l) => l.id === e.stockId.id
          );
          return `${location.name}: ${e.desiredAmount}`;
        })
        .join(" | ");
    },

    startEditing() {
      this.isEditing = true;
      this.changedProductCategories = [];
      this.changedProductPricings = [];
    },
    async cancelEdit() {
      this.isEditing = false;

      await this.$store.dispatch("pimVenues/getVenue", this.activeVenueId);
    },

    onChangedPrice(product, price) {
      //Remove product from changedProductPricings if it already exists
      this.changedProductPricings = this.changedProductPricings.filter(
        (x) => x.stockProductId !== product.stockProductId.id
      );

      // Then add the change
      this.changedProductPricings.push({
        stockProductId: product.stockProductId.id,
        price,
      });
    },

    onChangedPouringCategory(product, pouringCategoryId) {
      //Remove product from changedProductCategories if it already exists
      this.changedProductCategories = this.changedProductCategories.filter(
        (x) => x.stockProductId !== product.stockProductId.id
      );

      // Then add the change
      this.changedProductCategories.push({
        stockProductId: product.stockProductId.id,
        venueProductCategoryId: pouringCategoryId,
      });
    },

    async savePouringCategories() {
      console.log("SAVING", this.changedProductCategories);

      const categoryDto = {
        venueProductCategories: this.changedProductCategories,
      };

      const pricingDto = {
        prices: this.changedProductPricings,
      };

      try {
        await this.$store.dispatch("pimVenues/updateVenueProductCategories", {
          venueId: this.activeVenueId,
          dto: categoryDto,
        });

        await this.$store.dispatch("pimVenues/updateVenuePricing", {
          venueId: this.activeVenueId,
          dto: pricingDto,
        });

        this.$vs.notify({
          title: "Products saved",
          text: "The product changes has been saved",
        });

        // Wait 1 second before refetching
        await new Promise((resolve) => setTimeout(resolve, 1000));

        await this.$store.dispatch(
          "pimVenues/getVenuePricing",
          this.activeVenueId
        );
        await this.$store.dispatch("pimVenues/getVenue", this.activeVenueId);
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Categories not saved",
          text: err,
          time: 4000,
        });
      }

      this.isEditing = false;
    },

    async removeCategory(productId) {
      const dto = {
        stockProductIds: [productId],
      };

      try {
        const result = await this.$store.dispatch(
          "pimVenues/deleteVenueProductCategories",
          {
            venueId: this.activeVenueId,
            dto,
          }
        );

        this.$vs.notify({
          title: "Pouring categories deleted",
          text: "The pouring category assignments has been deleted",
        });

        await this.$store.dispatch("pimVenues/getVenue", this.activeVenueId);
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Categories not deleted",
          text: err,
          time: 4000,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      stockProducts: "stockProducts/stockProducts",
      totalProductsCount: "stockProducts/totalProductsCount",
      pimStockLocations: "venues/pimStockLocations",
      activeVenueId: "venues/activeVenueId",
      venueInventoryStatus: "pimVenues/venueInventoryStatus",

      venuePouringCategoryAssignments:
        "pimVenues/venuePouringCategoryAssignments",

      venuePricing: "pimVenues/venuePricing",

      pouringCategories: "venueProductCategories/pouringCategories",
    }),
    filteredVenueStock() {
      if (!this.venueInventoryStatus) return [];

      return this.venueInventoryStatus.products
        .filter((e) => {
          const pouringCategory = this.venuePouringCategoryAssignments.find(
            (x) => x.stockProductId.id === e.stockProductId.id
          );

          if (this.filters.pouringCategory) {
            return (
              pouringCategory &&
              pouringCategory.venueProductCategoryId.id ===
                this.filters.pouringCategory
            );
          }

          return true;
        })
        .map((e) => {
          const pouringCategory = this.venuePouringCategoryAssignments.find(
            (x) => x.stockProductId.id === e.stockProductId.id
          );

          const salesPrice = this.venuePricing.prices.find(
            (x) => x.stockProductId.id === e.stockProductId.id
          );

          return {
            ...e,
            pouringCategory,
            salesPrice: salesPrice ? salesPrice.price : 0,
          };
        });
    },
  },

  async created() {
    this.isLoading = true;

    try {
      await Promise.all([
        this.$store.dispatch("getRoleInstances"),
        this.$store.dispatch(
          "pimVenues/getVenueInventoryStatus",
          this.activeVenueId
        ),
        this.$store.dispatch("pimVenues/getVenue", this.activeVenueId),
        this.$store.dispatch("pimVenues/getVenuePricing", this.activeVenueId),
        this.$store.dispatch("venues/getPimStockLocations", this.activeVenueId),
        this.$store.dispatch("venueProductCategories/getPouringCategories"),
      ]);
    } catch (err) {
      let message = err;
      if (err.error) message = err.error;

      this.$vs.notify({
        title: "Could not load stock",
        text: message,
        color: "danger",
        time: 5000,
      });
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
